module.exports = __webpack_public_path__ + "static/media/whitelogo.d2f2461d.png";